import React, { useState, useEffect  } from 'react'
import './msquiz.css'
import { headerImg } from '../home/data';
import { quizImg } from './quizdata';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LazyImage from '../LazyImage';

function Startquiz({studentId,emailId,quizId}) {

    const location = useLocation();
    const examId = location.state?.examId;
    // console.log('examId',examId);
    
    const navigate = useNavigate();
    useEffect(() => {
        if (!location.state?.examId) {
        navigate('/', { replace: true });
        }
    }, [location.state, navigate]);
    
    const [studentName, setStudentname] = useState('');
    const [email, setEmail] = useState('');
    const [nameError, setNameError] = useState(false);
    const [emailError, setEmailError] = useState(false);

    const userName = (event)=>{
    if(!/^[a-zA-Z ]$/.test(event.key) && event.key.length === 1){
        event.preventDefault();
    }
    }

    const emailValidation = (event)=>{
    if(!/^[a-zA-Z0-9@._-]$/.test(event.key) && event.key.length === 1){
        event.preventDefault();
    }
    }
    
    const sendData = (e) => {
        e.preventDefault();

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isEmailValid = emailRegex.test(email);

        if(studentName === ''){
            setNameError(true);
            return;
        }

        if (!isEmailValid) {
            setEmailError(!isEmailValid);
            return;
        }
            
            try
            {
                const elem = document.documentElement;
                if(elem.requestFullscreen){
                    elem.requestFullscreen();
                } else if (elem.mozRequestFullScreen){
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen){
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen){
                    elem.msRequestFullscreen();
                }
            }
            catch (error){
                console.error('Fullscreem request failed:', error);
            }

            studentId(studentName);
            emailId(email);
            quizId(examId);
            setStudentname('');
            setEmail('');
            setNameError(false);
            setEmailError(false);

    }
  return (
    <div>
        <div className="container-2">
            {/* <img src={headerImg.header_img_url} alt="logo" style={{width: '100%', height: '215px'}}/> */}
            <LazyImage src={headerImg.header_img_url} alt="logo" className="#" style={{width: '100%', height: '215px'}} />
        </div>
        <h1>Quiz Session</h1>
        <div className='container-fluid quiz-bg-color'>

            <div className="container quiz-container">

                <div className="col-md-5">
                    <img className="gif" src={quizImg.quizUrl} alt="quiz" />
                </div>

                <div className="right-container col-md-7">

                    <div className="quiz-instructions mb-4 p-3 rounded bg-light">
                        <h5 className="mb-3">📝 Instructions Before You Begin</h5>
                            <ul className="list-unstyled">
                                <li>1️⃣ Quiz duration is <strong>10 minutes</strong>.</li>
                                <li>2️⃣ <strong>Do not press ESC</strong> or exit full-screen mode during the quiz.</li>
                                <li>3️⃣ If full-screen mode is exited, the quiz will auto-submit within <strong>15 seconds</strong>.</li>
                                <li>4️⃣ Please fill in your <strong>candidate details</strong> correctly below before starting.</li>
                                <li>5️⃣ Stay focused, read questions carefully, and manage your time wisely.</li>
                                <li>6️⃣ All the best! We believe in you.</li>
                            </ul>
                    </div>

                    <div className="mb-4 p-3 rounded bg-light quiz-form-container">
                        <form onSubmit={sendData} noValidate>

                                <div className="quizTitle">
                                    <label htmlFor="validationName" className="form-label" style={{width:'100%'}}>User Name</label>
                                    <div className="input-group has-validation">
                                        <input type="text" 
                                            name= 'studentName'
                                            id='validationName'
                                            onKeyDown={userName}
                                            value={studentName}
                                            placeholder='Name'
                                            maxLength={50}
                                            className={`form-control ${nameError ? 'is-invalid' : ''}`}
                                            onChange={(e)=>{ setStudentname(e.target.value); if (nameError) setNameError(false);}} 
                                            autoComplete='off'
                                            required/>
                                    <div className="invalid-feedback">In Validated!</div>
                                    </div>
                                </div>
                                <div className="quizTitle">
                                    <label htmlFor="validationemail" className="form-label" style={{width:'100%'}}>Email Id</label>
                                    <div className="input-group has-validation">
                                    <span className="input-group-text" id="inputGroupPrepend">@</span>
                                    <input
                                        type="email"
                                        placeholder='Gmail Id'
                                        className={`form-control ${emailError ? 'is-invalid' : ''}`}
                                        id="validationemail"
                                        aria-describedby="inputGroupPrepend"
                                        autoComplete='off'
                                        onKeyDown={emailValidation}
                                        name="email"
                                        value={email}
                                        onChange={(e) => { setEmail(e.target.value); if (emailError) setEmailError(false); }}
                                        required/>
                                    <div className="invalid-feedback">Please provide a valid Mail.</div>
                                    </div>
                                </div>
                                
                                <div className="quiz-btn">
                                    <button className="btn btn-primary" type='submit'>Start Exam</button>
                                </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
  )
}

export default Startquiz